import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "user/store/useAuthStore";

export default function RedirectRoute() {
    const accessToken = useAuthStore(state => state.accessToken);

    if (!accessToken) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}
